import {SurveyDefinitionModel} from "data/models/survey";
import {
  EventDescriptionWordsQuestion,
  ServiceDescriptionWordsTitle,
  WhatMakesYouSpecialParagraph1, WhatMakesYouSpecialParagraph2,
  WhatMakesYouSpecialTitle
} from "components/Survey/survey-sections-rendering-components/WhatMakesYouSpecialTitles";
import brandAlignmentChoiceListsSheet from "data/definition/surveys/brand-alignment-choice-lists";
import {
  RankBenefitsAndTraitsDescription,
  WhatSetsApartDescription
} from "components/Survey/survey-sections-rendering-components/DifferentiatorsTitles";
import {DIFFERENTIATORS_CHOICE_LIST} from "data/definition/surveys/differentiators-choice-list";


export const WHAT_MAKES_YOU_SPECIAL: SurveyDefinitionModel = {
  id: "what-makes-you-special",
  surveyQuestions: [
    {
      id: "what-makes-you-special",
      title: WhatMakesYouSpecialTitle,
      description: null,
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "center",
        paragraphs: [
          WhatMakesYouSpecialParagraph1,
          WhatMakesYouSpecialParagraph2,
        ],
      },
    }, {
      id: "product-description-words",
      title: "What words describe your product?",
      description: "What makes your product unique and special?",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: {
          question: "Do you sell a physical product that you have created or designed?",
          description: "Some examples are beer, candles, clothing, wedding cakes, cosmetics, jewelry, etc. It’s OK if your product or the packaging is not done yet. Describe how you imagine it. If you just sell other people’s products, choose ‘no’."
        },
        otherInputBox: false,
        choices: brandAlignmentChoiceListsSheet["product-description-words"],
      },
    }, {
      id: "service-description-words",
      title: ServiceDescriptionWordsTitle,
      description: "When you are a service-based business, how you interact with customers becomes part of your brand. What words do you want to come to mind when someone thinks about your service?",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        otherInputBox: false,
        enablingQuestion: {
          question: "Does your business provide a service?",
          description: "If you interact directly with your customers or clients in person, by phone, or virtually, you provide a service. This includes talking with them, serving them, or helping them with your skills and expertise.",
        },
        choices: brandAlignmentChoiceListsSheet["service-description-words"],
      },
    }, {
      id: "location-description-words",
      title: "Describe the atmosphere at your location or physical space.",
      description: "If you haven’t finished building, decorating, or creating your space yet, but you plan to have one, describe how you picture it in your head.",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        enablingQuestion: {
          question: "Does your business include a physical space?",
          description: "Do people come to your business' physical location such as a retail store, restaurant, food truck, office, or training center?",
        },
        sorted: true,
        otherInputBox: false,
        choices: brandAlignmentChoiceListsSheet["location-description-words"],
      },
    }, {
      id: "event-description-words",
      title: "Describe the feeling of participating in your event, program, or experience.",
      description: "What is the experience during your event or the feeling someone will walk away with after taking part in your program?",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        enablingQuestion: {
          question: EventDescriptionWordsQuestion,
          description: "These may include events, in-person or online educational programs, tours, shows, etc.",
        },
        sorted: true,
        otherInputBox: false,
        choices: brandAlignmentChoiceListsSheet["event-description-words"],
      },
    }, {
      id: "digital-description-words",
      title: "Describe what it feels like to use your app, software, website, or online program.",
      description: null,
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        enablingQuestion: {
          question: "Do you have an online business?",
          description: "If you have an e-commerce store, an app, software, or an online program, you have an online business. While some websites are robust and part of the brand experience, if you just have a website for marketing purposes, choose ‘no’.",
        },
        sorted: true,
        otherInputBox: false,
        choices: brandAlignmentChoiceListsSheet["digital-description-words"],
      },
    }, {
      id: "picture-of-your-brand",
      title: "Did you miss anything?",
      description: "What other adjectives come to mind when you envision your brand? (Note: If you've already selected these words on a previous screen, you don't need to add them again. It's also OK if you add them more than one time).",
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: false,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: null,
        otherInputBox: false,
        choices: brandAlignmentChoiceListsSheet["picture-of-your-brand"],
      },
    }, {
      id: "rank-benefits-and-traits",
      title: "Let’s rank these descriptions.",
      description: RankBenefitsAndTraitsDescription,
      kind: "rank-order",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        maxResultCount: 7,
        choicesSources: [
          "product-description-words",
          "service-description-words",
          "location-description-words",
          "event-description-words",
          "digital-description-words",
          "picture-of-your-brand",
        ],
      },
    }, {
      id: "differentiator",
      title: "What sets you apart?",
      description: WhatSetsApartDescription,
      kind: "multi-choice-select",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        enablingQuestion: null,
        otherInputBox: true,
        choices: DIFFERENTIATORS_CHOICE_LIST,
      },
    },{
      id: "differentiators-ranked",
      title: "Now rank these differentiators.",
      description: "Put your most important or distinctive qualities first. Choose up to 5.",
      kind: "rank-order",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        sorted: true,
        maxResultCount: 5,
        choicesSources: [
          "differentiator",
        ],
      },
    },
  ],
};
